// Entry point for the build script in your package.json

require("@rails/ujs").start()
require("@rails/activestorage").start()

import "./jquery"
import "./jquery-ui"
import "./jquery.ui.touch-punch"

import "./admin/location_plans.js"
import "./admin/insurer_templates.js"
import "./jSignature.min.js"
import "./credit_cards.js"
import "./user_profiles.js"
import "./covid_test_claim_submissions.js"
import "./camera.js"
import "./files.js"
import "./user_insurance_information.js"
import "./user_insurance_information_members.js"
import "./users.js"
import "./controllers"
import { Turbo } from "@hotwired/turbo-rails"
import { registerTurboStreamRedirect } from "./lib/turbo_stream_redirect.mjs"

// Custom Turbo Stream action: redirect
// Usage from Rails: turbo_stream.action(:redirect, some_path)
registerTurboStreamRedirect(Turbo)
import "./forms.js"
import "./check_for_bad_urls.js"
import { spinnerCycler } from "./spinner_cycler"
import { installFetchSessionExpiryInterceptor, notifySessionExpired, responseIndicatesSessionExpired, responseRedirectedToLogin } from "./lib/session_expired.mjs"

// Global "you've been logged out" detection across all request transports, so an
// expired session surfaces a single "log back in" toast instead of a generic
// error (or a silently-injected login page). See docs/session_expired_toast.md.
//
// 1) jQuery $.ajax — drawers (drawer_controller.js) and legacy JS. Warden returns
//    a 401 for these XHRs; this global handler catches every one at once. Guarded so a
//    future bundle change that reorders imports can't throw here and abort the rest of
//    application.js (Stimulus registration, etc.).
if (window.$?.fn) {
  window.$(document).ajaxError((_event, xhr) => {
    if (responseIndicatesSessionExpired(xhr.status, (name) => xhr.getResponseHeader(name))) {
      notifySessionExpired()
    }
  })
}

// 2) Turbo (frames / streams / drive). Auth failures for navigational Turbo
//    requests already 302-redirect to the sign-in page; this is a backstop for any
//    401 that reaches a Turbo fetch so it shows the toast rather than failing quietly.
document.addEventListener("turbo:before-fetch-response", (event) => {
  const response = event.detail?.fetchResponse?.response
  if (!response) return
  if (responseIndicatesSessionExpired(response.status, (name) => response.headers.get(name))) {
    notifySessionExpired()
  }
})

// 3) Native fetch() — the ~30 controllers that call fetch() directly. Reads only
//    status/headers, so the caller's Response body is left untouched.
installFetchSessionExpiryInterceptor(window)

// 4) Rails UJS (@rails/ujs) remote forms/links dispatch ajax:error (a native XHR,
//    not jQuery's ajaxError), so cover it explicitly.
document.addEventListener("ajax:error", (event) => {
  const xhr = event.detail?.[2]
  if (!xhr || typeof xhr.getResponseHeader !== "function") return
  if (responseIndicatesSessionExpired(xhr.status, (name) => xhr.getResponseHeader(name))) {
    notifySessionExpired()
  }
})

// 5) Turbo Frames — a lazy/navigational frame request whose session expired gets a 302
//    that fetch follows to the login page (200, untagged), so Turbo can't find the frame
//    and fires turbo:frame-missing. Show the toast and stop Turbo from rendering login
//    HTML into the frame. (Intentional full-page logout redirects don't hit this — they're
//    a normal Turbo Drive visit, not a missing frame.)
document.addEventListener("turbo:frame-missing", (event) => {
  if (responseRedirectedToLogin(event.detail?.response)) {
    event.preventDefault()
    notifySessionExpired()
  }
})

import LocalTime from "local-time"
LocalTime.start()

// After a Turbo page change, ensure we have the latest CSRF token on all forms.
// https://stackoverflow.com/questions/55040734/csrf-token-error-occurs-when-using-turbolinks-with-ruby-on-rails
import Rails from "@rails/ujs"
document.addEventListener("turbo:load", () => {
  console.log('[application.js] turbo:load event fired')
  Rails.refreshCSRFTokens();
  // Clean up disconnected spinners and initialize spinner cycling for any spinners on the page
  spinnerCycler.cleanupDisconnectedElements()
  spinnerCycler.initializeSpinners();
});

// Load analytics as the last step, so it doesn't interfere with Turbo's handling of links/forms.
if (typeof (initInspectlet) !== "undefined") {
  initInspectlet();
}
if (typeof (initHeap) !== "undefined") {
  initHeap();
}
